import { useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { insightsMessages } from './insightsMessages';

/**
 * The crumbs after the group on an Insights tab: "Insights / Streaming" (design navigation-v2 b).
 * The page head adds the group ("Your music") in front.
 */
export function useInsightsCrumbs(tab: MessageDescriptor): string[] {
  const intl = useIntl();
  return useMemo(() => [intl.formatMessage(insightsMessages.title), intl.formatMessage(tab)], [intl, tab]);
}
